import React from 'react';
import WhatsAppButton from '../Components/WhatsAppButton';

const ContactPage = () => {
  return (
    <div className="bg-zinc-900 py-20 sm:py-28">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="font-montserrat text-4xl md:text-5xl font-bold">Contact Us</h1>
          <div className="mt-2 mx-auto h-1 w-20 bg-accent-red"></div>
        </div>
        <div className="max-w-3xl mx-auto">
          <p className="mt-6 text-lg text-neutral-300 leading-relaxed text-center">
            If you have any questions, please feel free to reach out to us.
          </p>
          <ul className="mt-8 text-lg text-neutral-300 leading-relaxed">
            <li className="mb-4"><strong>Email:</strong> <a href="mailto:sales@brickandclay.co.za" className="text-accent-red hover:underline">sales@brickandclay.co.za</a></li>
            <li className="mb-4">
              <img src={require('../Photos/facebook-logo.svg').default} alt="Facebook Logo" className="inline-block w-6 h-6 mr-2" />
              <strong>Facebook:</strong> <a href="https://www.facebook.com/nigelbricksales/" target="_blank" rel="noopener noreferrer" className="text-accent-red hover:underline">Nigel Brick and Clay</a>
            </li>
            <li className="mb-4"><strong>Tel:</strong> <a href="tel:+27832759672" className="text-accent-red hover:underline">+27 83 275 9672</a></li>
            <li className="mb-4"><strong>Tel:</strong> <a href="tel:+27118146556" className="text-accent-red hover:underline">+27 11 814 6556</a></li>
            <li><strong>Address:</strong> 2 Marievale Road, Vorsterskroon, Nigel, South Africa</li>
          </ul>
          <div className="mt-12">
            <iframe
              width="100%"
              height="450"
              style={{ border: 0 }}
              src="https://maps.google.com/maps?q=Nigel%20Brick%20and%20Clay&t=&z=13&ie=UTF8&iwloc=&output=embed"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
      <WhatsAppButton />
    </div>
  );
};

export default ContactPage;